import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EnumInvoiceStatus, serviceOptions } from 'api';
import downloadInvoiceUrl from 'constants/download';
import InvoiceDocumentType from 'constants/invoiceDocumentTypes';
import downloadLink from 'utils/download/downloadLink';
import { paidByBalanceDownloadUrl, remittanceDetailsDownloadUrl } from 'constants/urls';
import downloadBlob from 'utils/download/downloadBlob';
const useDownloadInvoice = invoice => {
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);
  const determineDocumentType = () => {
    if (!invoice) return null;
    const {
      invoiceStatus,
      issueDateForPaymentReminder,
      newDueDate
    } = invoice;
    if (invoiceStatus === EnumInvoiceStatus.CreditNote) return InvoiceDocumentType.CreditNote;
    if (issueDateForPaymentReminder !== null || newDueDate !== null) return InvoiceDocumentType.Reminder;
    return InvoiceDocumentType.Invoice;
  };
  const downloadInvoice = async () => {
    if (!invoice) return;
    const {
      invoiceId
    } = invoice;
    if (!invoiceId) return;
    if (invoice.invoiceStatus === EnumInvoiceStatus.Remittance) {
      const url = remittanceDetailsDownloadUrl(invoice.invoiceNumber);
      const fileName = `Remittance-details-${invoice.invoiceNumber}`;
      return downloadDocument(url, fileName);
    } else if (invoice.invoiceStatus === EnumInvoiceStatus.PaidByBalance) {
      const url = paidByBalanceDownloadUrl(invoice.invoiceNumber);
      const fileName = `Invoice-details-${invoice.invoiceNumber}`;
      return downloadDocument(url, fileName);
    } else {
      try {
        setDownloadIsLoading(true);
        const url = downloadInvoiceUrl(invoiceId, determineDocumentType());
        const result = await serviceOptions.axios?.request({
          method: 'GET',
          url
        });
        if (!result?.data) return;
        await downloadLink(result?.data);
      } catch (e) {
        console.error(e);
        const message = t('error.download_invoice');
        enqueueSnackbar(message, {
          variant: 'error'
        });
      } finally {
        setDownloadIsLoading(false);
      }
    }
  };
  const downloadDocument = async (url, fileName) => {
    try {
      setDownloadIsLoading(true);
      return await downloadBlob(url, fileName);
    } catch (e) {
      console.error(e);
      const message = t('error.download_invoice');
      enqueueSnackbar(message, {
        variant: 'error'
      });
    } finally {
      setDownloadIsLoading(false);
    }
  };
  return {
    downloadInvoice,
    downloadIsLoading
  };
};
export default useDownloadInvoice;